

















































































































import { useUpdateFactoryImage } from '@/lib/imageUpload'
import { updateFactoryImages, updateFactory } from '@/api'
import { computed, createComponent, inject, reactive, ref } from '@vue/composition-api'
import { useGA } from '@/lib/useGA'
import { useAppState } from '../lib/appState'
import { useModalState } from '../lib/hooks'
import ImageUploadForm from './ImageUploadForm.vue'
import { MainMapControllerSymbol } from '@/symbols'
import { MapFactoryController } from '@/lib/map'
import { REPORT_TYPE } from '@/types'

export default createComponent({
  name: 'UpdateFactorySteps',
  components: {
    ImageUploadForm
  },
  setup () {
    const [appState, { pageTransition }] = useAppState()
    const [, modalActions] = useModalState()
    const mapController = inject(MainMapControllerSymbol, ref<MapFactoryController>())
    const { event } = useGA()

    const {
      selectedImages,
      imageUploadState,
      uploadedImages,
      onClickRemoveImage,
      imageUploadFormValid
    } = useUpdateFactoryImage()

    const imageUploadFormState = reactive({
      nickname: '',
      contact: ''
    })

    const imageSubmitting = ref(false)
    const imagesValid = computed(() => imageUploadFormValid.value && !imageSubmitting.value)
    const submitImageUpload = async () => {
      if (!appState.factoryData?.id || !selectedImages.value) {
        return
      }

      imageSubmitting.value = true

      try {
        const newImages = await updateFactoryImages(
          appState.factoryData?.id,
          selectedImages.value, {
            nickname: imageUploadFormState.nickname,
            contact: imageUploadFormState.contact
          }
        )

        if (mapController.value) {
          const factory = appState.factoryData
          factory.images = factory.images.concat(newImages)

          mapController.value.updateFactory(factory.id, factory)
          appState.factoryData = factory
        }

        pageTransition.cancelUpdateFactoryImages()
        modalActions.openUpdateFactoryImagesSuccessModal()
      } catch (err) {
        console.error(err)
      }

      imageSubmitting.value = false
    }

    const discardDialog = ref(false)

    const cancelUpdateFactoryImages = () => {
      discardDialog.value = false
      pageTransition.cancelUpdateFactoryImages()
    }

    const cancelUpdateFactory = () => {
      discardDialog.value = false
      pageTransition.cancelUpdateFactoryComment()
    }

    const formState = reactive({
      others: '',
      name: appState.factoryData?.name,
      // eslint-disable-next-line @typescript-eslint/camelcase
      factory_type: appState.factoryData?.type,
      submitting: false
    })

    const reportTypeItems: Array<{ text: string, value?: string }> = [
      ...REPORT_TYPE
    ]

    const validStates = {
      others: computed(() => formState.others.length > 0 && !formState.submitting),
      name: computed(() => formState?.name?.length && formState.name?.length > 0 && !formState.submitting),
      // eslint-disable-next-line @typescript-eslint/camelcase
      factory_type: computed(() => !!formState.factory_type && !formState.submitting)
    }

    const isCurrentFieldValid = computed(() => {
      const field = appState.updateFactoryField as 'others' | 'name' | 'factory_type'
      return validStates[field].value
    })

    const updateFormAppTitle = computed(() => {
      return appState.isEditComment ? '補充黑熊出沒痕跡描述'
        : appState.isEditName ? '更改外部文字' : '更改黑熊出沒痕跡類型'
    })

    const updateFormTitle = computed(() => {
      if (appState.isEditComment) {
        return '黑熊出沒痕跡描述'
      } else if (appState.isEditName) {
        return '黑熊出沒痕跡外部文字'
      } else if (appState.isEditType) {
        return '黑熊出沒痕跡類型'
      }
    })

    const updateFormButton = computed(() => {
      if (appState.isEditComment) {
        return '新增黑熊出沒痕跡描述'
      } else if (appState.isEditName) {
        return '確認更改黑熊出沒痕跡外部文字'
      } else if (appState.isEditType) {
        return '確認更改黑熊出沒痕跡類型'
      }
    })

    const submitUpdateFactory = async () => {
      if (!appState.factoryData?.id || !isCurrentFieldValid.value) {
        return
      }

      formState.submitting = true

      try {
        const field = appState.updateFactoryField as 'others' | 'name' | 'factory_type'

        event('updateFactory', { field })
        const factory = await updateFactory(appState.factoryData?.id, {
          [field]: formState[field]
        })

        if (mapController.value) {
          mapController.value.updateFactory(factory.id, factory)
          appState.factoryData = factory
        }

        // TOOD: comments not displayed or stored in factory data for now

        pageTransition.cancelUpdateFactoryComment()
        modalActions.openUpdateFactorySuccessModal()
      } catch (err) {}

      formState.submitting = false
    }

    return {
      appState,
      pageTransition,

      discardDialog,
      imageUploadFormState,
      selectedImages,
      imageUploadState,
      uploadedImages,
      onClickRemoveImage,
      imagesValid,
      submitImageUpload,
      cancelUpdateFactoryImages,
      cancelUpdateFactory,

      updateFormAppTitle,
      updateFormTitle,
      updateFormButton,

      formState,
      isCurrentFieldValid,
      reportTypeItems,

      submitUpdateFactory
    }
  }
})
